import { WidgetType } from "@codemirror/view";

export class IconBraceWidget extends WidgetType {
    constructor(content = "") {
        super();
        this.content = content;
    }

    toDOM() {
        const element = document.createElement("span");
        element.classList.add("ol-cm-icon-brace");
        element.textContent = this.content;
        return element;
    }

    eq(widget) {
        return widget.content === this.content;
    }

    updateDOM(element) {
        element.textContent = this.content;
        return true;
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }
}
